import { Component, Input } from '@angular/core';
import { Login } from '../../models/loginmodel';
import { Session } from '../../models/sessionmodel';
import { loginService } from '../../services/login.service';
import { SharedService } from '../../services/sharedservices.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { PersistenceService } from 'angular-persistence';
import * as CryptoJS from 'crypto-js';
// import { config } from 'config/config';

import jwt from 'jsonwebtoken';
import {config} from '../../config/config';


@Component({
  //selector: 'app-root',
  templateUrl: './login.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [loginService]
})

export class LoginComponent {
  public responseObj: Session;
  login: Login;
  errorMessage: string;
  public isAdmin = false;

  constructor(private _LoginService: loginService, public router: Router, public sharedservice: SharedService) {
  }

  ngOnInit() {
    // call the method on initial load of page to bind dropdown
    this.responseObj = new Session();
    this.login = new Login();

    // this.sharedservice.checkCredentials();
  }

  postLogin(isValid: boolean) {
    //console.log("Login: " + this.login);
    if (isValid) {
      this._LoginService.postLogin(this.login).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }

  handleResponse(res) {
    let body = res["_body"];
    let conversionOutput = CryptoJS.AES.decrypt(body, config.key).toString(CryptoJS.enc.Utf8);
    console.log("conversionOutput: "+conversionOutput);
    this.responseObj = JSON.parse(conversionOutput);
    this.sharedservice.session = JSON.parse(conversionOutput);
    console.log("body: " + body);
    if (this.responseObj.account_status === '1') {
      this.router.navigate(['mca']);
    } else {
      this.router.navigate(['login']);
    }

    /*let body = res["_body"];
    let conversionOutput = CryptoJS.AES.decrypt(body, config.key).toString(CryptoJS.enc.Utf8);
    this.responseObj = JSON.parse(conversionOutput);
    if (this.responseObj.account_status === '1') {

      //localStorage.setItem('mca_d', body);
      this.router.navigate(['mca']);
    } else {
      this.router.navigate(['login']);
    }*/


  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/login/login.component.ts